global.initSignUpForm = () => import('./pages/sign_up').then(module => module.initSignUpForm());
global.userRegistrationGA = (dataLayer) => import('./signup_flow_ga').then(module => module.userRegistrationGA(dataLayer));
